import React from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import MyHeader from './Header.module.css';
import Logo from '../Logo/Logo';
import DocumentTitle from '../DocumentTitle/DocumentTitle';
import Navigations from '../Navigations/Navigations';
import SavingSaved from '../SavingSaved';
import CompleteDocument from '../CompleteDoc/completeDoc';
import RightHeader from './RightHeader';
import publicIcon from '../../assets/world.svg';
import privateIcon from '../../assets/lock.svg';
import { useFullView, useFullViewShortcut } from '../../utils/fullView';

/**
 * One 56px bar, laid out like milegrid's: the logo, then the title over a
 * second line that carries the File / Edit / Insert / Format / View menus and
 * the saved status, then the actions on the right. Full view (the chevron tab
 * that hangs below the bar, View > Full screen, Ctrl+Shift+F) hides the bar
 * so the document gets the height back.
 */
const Header = ({ isMobile }) => {
  const documentInformation = useSelector((state) => state.editor.documentInformation);
  const isReadOnly = useSelector((state) => state.editor.isReadOnly);
  const isTemplateDocument = useSelector((state) => state.editor.isTemplateDocument);
  const [fullView, toggleFullView] = useFullView();
  useFullViewShortcut();

  return (
    <div id="myy-header" className={`my-header ${MyHeader.header}`}>
      <div className={`header-top-bar ${MyHeader.topBar}`}>
        <Logo isMobile={isMobile} />
        <div className={MyHeader.titleBlock}>
          <div className={MyHeader.titleRow}>
            <DocumentTitle />
            {!isTemplateDocument && (
              documentInformation?.privacyId === 2 ? (
                <Tooltip title="Private document">
                  <img src={privateIcon} alt="Private document" style={{ width: '13px' }} />
                </Tooltip>
              ) : (
                <Tooltip title="Public document">
                  <img src={publicIcon} alt="Public document" style={{ width: '14px' }} />
                </Tooltip>
              )
            )}
            {!isReadOnly && !isTemplateDocument && <CompleteDocument />}
          </div>
          <div className={MyHeader.statusRow}>
            {!isReadOnly && <Navigations />}
            {!isReadOnly && <span className={MyHeader.statusDivider} />}
            <SavingSaved />
          </div>
        </div>
        <div className={MyHeader.spacer} />
        <RightHeader isMobile={isMobile} />
      </div>
      <Tooltip
        title={fullView ? 'Show header' : 'Full view (Ctrl+Shift+F)'}
        placement="left"
        getPopupContainer={(node) => node.parentElement || document.body}
      >
        <button
          type="button"
          className={MyHeader.fullViewToggle}
          onClick={toggleFullView}
          aria-label={fullView ? 'Show header' : 'Full view'}
          aria-pressed={fullView}
        >
          {fullView ? <DownOutlined /> : <UpOutlined />}
        </button>
      </Tooltip>
    </div>
  );
};

export default Header;
